var WEBGL = {
    isWebGLAvailable: function () {
        try {
            var e = document.createElement("canvas");
            return !(!window.WebGLRenderingContext || (!e.getContext("webgl") && !e.getContext("experimental-webgl")));
        } catch (e) {
            return !1;
        }
    },
    isWebGL2Available: function () {
        try {
            var e = document.createElement("canvas");
            return !(!window.WebGL2RenderingContext || !e.getContext("webgl2"));
        } catch (e) {
            return !1;
        }
    },
    getWebGLErrorMessage: function () {
        return this.getErrorMessage(1);
    },
    getWebGL2ErrorMessage: function () {
        return this.getErrorMessage(2);
    },
    getErrorMessage: function (e) {
        var t = { 1: window.WebGLRenderingContext, 2: window.WebGL2RenderingContext },
            n = 'Your $0 does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">$1</a>',
            r = document.createElement("div");
        return (
            (r.id = "webglmessage"),
            (r.style.fontFamily = "monospace"),
            (r.style.fontSize = "13px"),
            (r.style.fontWeight = "normal"),
            (r.style.textAlign = "center"),
            (r.style.background = "#fff"),
            (r.style.color = "#000"),
            (r.style.padding = "1.5em"),
            (r.style.width = "400px"),
            (r.style.margin = "5em auto 0"),
            (n = (n = t[e] ? n.replace("$0", "graphics card") : n.replace("$0", "browser")).replace("$1", { 1: "WebGL", 2: "WebGL 2" }[e])),
            (r.innerHTML = n),
            r
        );
    },
};
